import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from '@clerk/clerk-react'
import { useCurrentHousehold } from '@/hooks/useCurrentHousehold'
import { capturePageview, identifyUser, resetAnalytics, setHouseholdGroup } from '@/lib/analytics'

/** Headless — wires PostHog to the app's runtime: a pageview per route change, identify on
 *  sign-in / reset on sign-out, and the active household as a group. No-ops when analytics
 *  is disabled (no key). */
export function AnalyticsBootstrap() {
  const { pathname } = useLocation()
  const { isSignedIn, userId } = useAuth()
  const { householdId } = useCurrentHousehold()
  const wasSignedIn = useRef<boolean | undefined>(undefined)

  useEffect(() => {
    capturePageview()
  }, [pathname])

  useEffect(() => {
    if (isSignedIn && userId) {
      identifyUser(userId)
    } else if (wasSignedIn.current && !isSignedIn) {
      resetAnalytics()
    }
    wasSignedIn.current = isSignedIn
  }, [isSignedIn, userId])

  useEffect(() => {
    if (householdId) setHouseholdGroup(householdId)
  }, [householdId])

  return null
}
